"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var twilsockerror_1 = require("./twilsockerror");

var TwilsockReplyError =
/*#__PURE__*/
function (_twilsockerror_1$Twil) {
  _inherits(TwilsockReplyError, _twilsockerror_1$Twil);

  function TwilsockReplyError(description, reply) {
    var _this;

    _classCallCheck(this, TwilsockReplyError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TwilsockReplyError).call(this, description));
    _this.reply = reply;
    return _this;
  }

  return TwilsockReplyError;
}(twilsockerror_1.TwilsockError);

exports.TwilsockReplyError = TwilsockReplyError;